import className from 'classnames/bind';
import style from '../style/Register.module.scss';
import {useEffect} from "react";
import {AuthRegisterForm, GoogleLoginButton} from "~/features/Auth/components";
import {globalNavigate} from "~/routes/GlobalHistory";
import {FontAwesomeIcon} from "~/components";

const cn = className.bind(style);

const FEATURES = [
    {icon: 'fa-light fa-magnifying-glass-chart', text: 'Chấm điểm SEO toàn diện theo 6 nhóm tiêu chí'},
    {icon: 'fa-light fa-ranking-star', text: 'Theo dõi thứ hạng & sức khoẻ website'},
    {icon: 'fa-light fa-shield-halved', text: 'Phân quyền linh hoạt cho từng thành viên'},
];

function Register() {

    const isLoggedIn = Boolean(localStorage.getItem('access_token'));

    useEffect(() => {
        if (isLoggedIn) {
            globalNavigate(process.env.REACT_APP_HOMEPAGE+"/");
        }
    }, [isLoggedIn]);

    return (
        <div className={cn('login-container')}>
            <div className={cn('login-connect')}>
                <div className={cn('mask')}></div>

                {/* decorative orbs */}
                <span className={cn('orb', 'orb-1')}></span>
                <span className={cn('orb', 'orb-2')}></span>
                <div className={cn('grid-overlay')}></div>

                <div className={cn('brand')}>
                    <span className={cn('brand-badge')}><FontAwesomeIcon icon="fa-light fa-chart-line"/></span>
                    <span className={cn('brand-name')}>Omni SEO</span>
                </div>

                <div className={cn('content')}>
                    <h2>Bắt đầu tối ưu SEO<br/>ngay hôm nay.</h2>
                    <p>Tạo tài khoản miễn phí để chấm điểm, theo dõi và quản trị SEO cho website của bạn.</p>

                    <div className={cn('features')}>
                        {FEATURES.map((f, i) => (
                            <div className={cn('feature')} key={i}>
                                <span className={cn('feature-icon')}><FontAwesomeIcon icon={f.icon}/></span>
                                <span>{f.text}</span>
                            </div>
                        ))}
                    </div>

                    {/* decorative score widget */}
                    <div className={cn('score-card')}>
                        <div className={cn('score-ring')}>
                            <span className={cn('score-value')}>92</span>
                            <span className={cn('score-label')}>SEO Score</span>
                        </div>
                        <div className={cn('score-bars')}>
                            <span style={{'--h': '60%'}}></span>
                            <span style={{'--h': '85%'}}></span>
                            <span style={{'--h': '45%'}}></span>
                            <span style={{'--h': '95%'}}></span>
                            <span style={{'--h': '70%'}}></span>
                        </div>
                    </div>
                </div>
            </div>

            <div className={cn('login-form')}>
                <div className={cn('login-form-wrapper')}>
                    <div className={cn('login-logo')}>
                        <span className={cn('login-logo-badge')}><FontAwesomeIcon icon="fa-light fa-chart-line"/></span>
                        <span className={cn('login-logo-name')}>Omni SEO</span>
                    </div>
                    <div className={cn('login-heading')}>
                        <h1>Tạo tài khoản mới</h1>
                        <p>Điền thông tin bên dưới để bắt đầu sử dụng Omni SEO.</p>
                    </div>
                    <div className={cn('login-form-inner')}>
                        <AuthRegisterForm/>
                        <GoogleLoginButton text="signup_with"/>
                    </div>
                    <div className={cn('login-switch')}>
                        Đã có tài khoản? <a href={process.env.REACT_APP_HOMEPAGE+"/login"}>Đăng nhập</a>
                    </div>
                    <div className={cn('login-footer')}>
                        <div>
                            Bằng việc đăng ký, bạn đồng ý với{' '}
                            <a href={process.env.REACT_APP_HOMEPAGE+"/terms"}>Điều khoản sử dụng</a> và{' '}
                            <a href={process.env.REACT_APP_HOMEPAGE+"/privacy-policy"}>Chính sách bảo mật</a> của Omni SEO.
                        </div>
                        <div style={{marginTop: 8}}>© {new Date().getFullYear()} Omni SEO. Bảo lưu mọi quyền.</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register;
